<template>
  <div
    :class="{
      'intro-block': true,
      'pt-26': pageName === 'home' && introBlockData.enable_top_space,
    }"
    v-if="Object.keys(introBlockData).length > 0"
    :style="{
      background: introBlockData.enable_bg_color
        ? $root.color_schema.primary
        : introBlockData.hasOwnProperty('custom_bg_color') &&
          introBlockData.custom_bg_color != ''
        ? introBlockData.custom_bg_color
        : null,
    }"
  >
    <div class="container">
      <TagBlock
        :attrs="{}"
        :title="introBlockData.title"
        :block="'introBlock'"
        :usTag="introBlockData.title_tag"
        :sty="
          introBlockData.enable_bg_color
            ? $root.color_schema.primary
            : introBlockData.hasOwnProperty('custom_bg_color') &&
              introBlockData.custom_bg_color != ''
            ? introBlockData.custom_bg_color
            : false
        "
        :colorEnable="introBlockData.enable_bg_color"
        :titleAlign="introBlockData.alignment"
      />
      <template v-if="introBlockData.enable_author_info && introBlockData.authors">
        <section class="author-section">
          <div class="container">
            <template v-if="
          blockStyle === 'big' &&
          !(introBlockData.authors.filter((ele) => ele.description === '').length > 0)
        ">
              <div :class="{
            'author-wrapper-big-card': true,
          }"
                   v-for="(data, index) in introBlockData.authors"
                   :key="'desk' + index">
                <div :class="{
              'author-img': true,
            }">
                  <img :src="data.user_avatar_url"
                       width="100"
                       height="100"
                       :alt="getAltText('', data.user_avatar_url)"/>
                  <div class="author-img-content">
                    <div>
                      <template v-if="
                    data.profile_data.slug === ''
                    && data.profile_data.post_type === ''
                  ">
                  <span class="span-h2 author-desktop-version">
                    {{data.display_name}}
                  </span>
                        <p class="mob-nam author-mobile-version">
                          {{ data.display_name }}
                        </p>
                      </template>
                      <template v-else>
                        <a :href="getRouteLink(data.profile_data.slug,data.profile_data.post_type)">
                      <span class="span-h2 author-desktop-version">
                        {{data.display_name}}
                      </span>
                          <p class="mob-nam author-mobile-version">
                            {{ data.display_name }}
                          </p>
                        </a>
                      </template>
                      <span class="span-title">{{ data.role_title }}</span>
                    </div>
                    <a :title="data.display_name"
                       v-if="
                  data.social_links &&
                  Object.keys(data.social_links).length > 0 &&
                  data.social_links.linkedin &&
                  data.social_links.linkedin != ''
                "
                       style="margin-left: 10px;"
                       :href="data.social_links.linkedin"
                       target="_blank"
                       rel="no-follow">
                      <svg width="16"
                           height="16"
                           viewBox="0 0 16 16"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z"
                              fill="lightgrey"/>
                      </svg>
                    </a>
                  </div>
                </div>
                <div :class="{
              'author-content': true,
            }">
                  <span class="span-h5">{{ i18n.about_the_author }}</span>
                  <p>{{ data.description }}</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-lg-3"
                     v-for="(data, index) in introBlockData.authors"
                     :key="'desk' + index">
                  <div class="author-wrapper-small-card">
                    <img :src="data.user_avatar_url"
                         width="100"
                         height="100"
                         :alt="getAltText('', data.user_avatar_url)"/>
                    <div class="author-img-content">
                      <div class="inner-wrap">
                        <template v-if="
                    data.profile_data.slug === ''
                    && data.profile_data.post_type === ''
                  ">
                          <p class="p-bold">
                            {{ data.display_name }}
                          </p>
                        </template>
                        <template v-else>
                          <a :href="getRouteLink(data.profile_data.slug,data.profile_data.post_type)">
                            <p class="p-bold">
                              {{ data.display_name }}
                            </p>
                          </a>
                        </template>
                        <a :title="data.display_name"
                           v-if="
                      data.social_links &&
                      Object.keys(data.social_links).length > 0 &&
                      data.social_links.linkedin &&
                      data.social_links.linkedin != ''
                    "
                           style="margin-left: 10px;"
                           :href="data.social_links.linkedin"
                           target="_blank"
                           rel="no-follow">
                          <svg width="16"
                               height="16"
                               viewBox="0 0 16 16"
                               fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z"
                                  fill="lightgrey"/>
                          </svg>
                        </a>
                      </div>
                      <span class="span-caption">{{ data.role_title }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 float-right justify-content-end pubdate">
                  <div class="publish-date text-right">
                    <span class="span-caption">
                      <svg width="12"
                           height="12"
                           viewBox="0 0 12 12"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 1.5H10V0.499969C10 0.22403 9.776 0 9.49997 0H9C8.72397 0 8.50003 0.22403 8.50003 0.499969V1.5H3.49997V0.499969C3.49997 0.22403 3.27603 0 3 0H2.50003C2.224 0 1.99997 0.22403 1.99997 0.499969V1.5H1.5C0.673004 1.5 0 2.173 0 3V10.5C0 11.327 0.673004 12 1.5 12H10.5C11.327 12 12 11.327 12 10.5V3C12 2.173 11.327 1.5 10.5 1.5ZM11 10.5C11 10.7755 10.7755 11 10.5 11H1.5C1.22452 11 1.00003 10.7755 1.00003 10.5V5.02002H11V10.5Z"
                              fill="#9B9B9B"/>
                      </svg>
                      {{ introBlockData.post_date_read_time }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </section>
      </template>
      <template v-if="introinnerWidth < 576">
        <template v-if="!introBlockData.disable_showmore_mobile">
          <template
            v-if="
              introBlockData.content.length > 0 &&
              introBlockData.content.length <
                44 * introBlockData.no_of_lines_mobile -
                  (introBlockData.no_of_lines_mobile === '1'
                    ? 0
                    : 3 * introBlockData.no_of_lines_mobile)
            "
          >
            <div
              :class="{
                'intro-content intro-content': true,
                'block-content-light': introBlockData.enable_bg_color
                  ? !getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? !getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'block-content-dark': introBlockData.enable_bg_color
                  ? getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'content-left': introBlockData.alignment === 'left',
                'content-center': introBlockData.alignment === 'center',
                'content-right': introBlockData.alignment === 'right',
              }"
              :style="{
                '--bg-color': introBlockData.enable_bg_color
                  ? $root.color_schema.primary
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? introBlockData.custom_bg_color
                  : false,
              }"
              v-html="introBlockData.content"
            ></div>
          </template>
          <template
            v-else-if="
              introBlockData.content.length > 0 &&
              introBlockData.content.length >=
                44 * introBlockData.no_of_lines_mobile -
                  (introBlockData.no_of_lines_mobile === '1'
                    ? 0
                    : 3 * introBlockData.no_of_lines_mobile)
            "
          >
            <div
              :class="{
                'intro-content intro-hover': true,
                'block-content-light': introBlockData.enable_bg_color
                  ? !getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? !getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'block-content-dark': introBlockData.enable_bg_color
                  ? getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'content-left': introBlockData.alignment === 'left',
                'content-center': introBlockData.alignment === 'center',
                'content-right': introBlockData.alignment === 'right',
              }"
              :style="{
                '--bg-color': introBlockData.enable_bg_color
                  ? $root.color_schema.primary
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? introBlockData.custom_bg_color
                  : false,
                'max-height': `${25 * introBlockData.no_of_lines_mobile}px`,
              }"
              v-html="introBlockData.content"
            ></div>
            <template v-if="introBlockData.disable_showmore_mobile"></template>
            <template v-else>
              <a
                :title="$root.i18n.show_more"
                v-if="!showFullText"
                :class="{
                  'show-cls': true,
                  'text-white': introBlockData.enable_bg_color
                    ? !getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? !getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'text-gray': introBlockData.enable_bg_color
                    ? getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'content-left': introBlockData.alignment === 'left',
                  'content-center': introBlockData.alignment === 'center',
                  'content-right': introBlockData.alignment === 'right',
                }"
                @click="showMoreText()"
                >{{ $root.i18n.show_more }}</a
              >
              <a
                :title="$root.i18n.show_less"
                v-else
                :class="{
                  'show-cls': true,
                  'text-white': introBlockData.enable_bg_color
                    ? !getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? !getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'text-gray': introBlockData.enable_bg_color
                    ? getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'content-left': introBlockData.alignment === 'left',
                  'content-center': introBlockData.alignment === 'center',
                  'content-right': introBlockData.alignment === 'right',
                }"
                @click="showMoreText()"
                >{{ $root.i18n.show_less }}</a
              >
            </template>
          </template>
        </template>
        <template v-else>
          <div
            :class="{
              'intro-content': true,
              'block-content-light': introBlockData.enable_bg_color
                ? !getContrastYIQ($root.color_schema.primary)
                : introBlockData.hasOwnProperty('custom_bg_color') &&
                  introBlockData.custom_bg_color != ''
                ? !getContrastYIQ(introBlockData.custom_bg_color)
                : false,
              'block-content-dark': introBlockData.enable_bg_color
                ? getContrastYIQ($root.color_schema.primary)
                : introBlockData.hasOwnProperty('custom_bg_color') &&
                  introBlockData.custom_bg_color != ''
                ? getContrastYIQ(introBlockData.custom_bg_color)
                : false,
              'content-left': introBlockData.alignment === 'left',
              'content-center': introBlockData.alignment === 'center',
              'content-right': introBlockData.alignment === 'right',
            }"
            v-html="introBlockData.content"
          ></div>
        </template>
      </template>
      <template v-else>
        <template v-if="!introBlockData.disable_showmore">
          <template
            v-if="
              introBlockData.content.length > 0 &&
              introBlockData.content.length <
                185 * introBlockData.no_of_lines -
                  (introBlockData.no_of_lines === '1'
                    ? 0
                    : 10 * introBlockData.no_of_lines)
            "
          >
            <div
              :class="{
                'intro-content intro-content': true,
                'block-content-light': introBlockData.enable_bg_color
                  ? !getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? !getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'block-content-dark': introBlockData.enable_bg_color
                  ? getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'content-left': introBlockData.alignment === 'left',
                'content-center': introBlockData.alignment === 'center',
                'content-right': introBlockData.alignment === 'right',
              }"
              :style="{
                '--bg-color': introBlockData.enable_bg_color
                  ? $root.color_schema.primary
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? introBlockData.custom_bg_color
                  : false,
                padding: `0 ${introBlockData.content_padding_lr}px`,
              }"
              v-html="introBlockData.content"
            ></div>
          </template>
          <template
            v-else-if="
              introBlockData.content.length > 0 &&
              introBlockData.content.length >=
                185 * introBlockData.no_of_lines -
                  (introBlockData.no_of_lines === '1'
                    ? 0
                    : 10 * introBlockData.no_of_lines)
            "
          >
            <div
              :class="{
                'intro-content intro-hover': true,
                'block-content-light': introBlockData.enable_bg_color
                  ? !getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? !getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'block-content-dark': introBlockData.enable_bg_color
                  ? getContrastYIQ($root.color_schema.primary)
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? getContrastYIQ(introBlockData.custom_bg_color)
                  : false,
                'content-left': introBlockData.alignment === 'left',
                'content-center': introBlockData.alignment === 'center',
                'content-right': introBlockData.alignment === 'right',
              }"
              :style="{
                '--bg-color': introBlockData.enable_bg_color
                  ? $root.color_schema.primary
                  : introBlockData.hasOwnProperty('custom_bg_color') &&
                    introBlockData.custom_bg_color != ''
                  ? introBlockData.custom_bg_color
                  : false,
                'max-height': `${25 * introBlockData.no_of_lines}px`,
                padding: `0 ${introBlockData.content_padding_lr}px`,
              }"
              v-html="introBlockData.content"
            ></div>
            <template v-if="introBlockData.disable_showmore"></template>
            <template v-else>
              <a
                :title="$root.i18n.show_more"
                v-if="!showFullText"
                :class="{
                  'show-cls': true,
                  'text-white': introBlockData.enable_bg_color
                    ? !getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? !getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'text-gray': introBlockData.enable_bg_color
                    ? getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'content-left': introBlockData.alignment === 'left',
                  'content-center': introBlockData.alignment === 'center',
                  'content-right': introBlockData.alignment === 'right',
                }"
                @click="showMoreText()"
                >{{ $root.i18n.show_more }}</a
              >
              <a
                :title="$root.i18n.show_less"
                v-else
                :class="{
                  'show-cls': true,
                  'text-white': introBlockData.enable_bg_color
                    ? !getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? !getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'text-gray': introBlockData.enable_bg_color
                    ? getContrastYIQ($root.color_schema.primary)
                    : introBlockData.hasOwnProperty('custom_bg_color') &&
                      introBlockData.custom_bg_color != ''
                    ? getContrastYIQ(introBlockData.custom_bg_color)
                    : false,
                  'content-left': introBlockData.alignment === 'left',
                  'content-center': introBlockData.alignment === 'center',
                  'content-right': introBlockData.alignment === 'right',
                }"
                @click="showMoreText()"
                >{{ $root.i18n.show_less }}</a
              >
            </template>
          </template>
        </template>
        <template v-else>
          <div
            :class="{
              'intro-content': true,
              'block-content-light': introBlockData.enable_bg_color
                ? !getContrastYIQ($root.color_schema.primary)
                : introBlockData.hasOwnProperty('custom_bg_color') &&
                  introBlockData.custom_bg_color != ''
                ? !getContrastYIQ(introBlockData.custom_bg_color)
                : false,
              'block-content-dark': introBlockData.enable_bg_color
                ? getContrastYIQ($root.color_schema.primary)
                : introBlockData.hasOwnProperty('custom_bg_color') &&
                  introBlockData.custom_bg_color != ''
                ? getContrastYIQ(introBlockData.custom_bg_color)
                : false,
              'content-left': introBlockData.alignment === 'left',
              'content-center': introBlockData.alignment === 'center',
              'content-right': introBlockData.alignment === 'right',
            }"
            v-html="introBlockData.content"
          ></div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import TagBlock from "@/components/custom-block/TagBlock";
import { pSBC, getContrastYIQ } from "@/misc/misc-function";

export default {
  name: "IntroBlock",
  props: ["introBlockData", "pageName"],
  data() {
    return {
      showFullText: false,
      introinnerWidth: 0,
    };
  },
  components: {
    TagBlock,
  },
  methods: {
    pSBC,
    getContrastYIQ,
    showMoreText: function () {
      this.showFullText = !this.showFullText;
      if (this.showFullText) {
        document.querySelector(".intro-content").classList.add("none-height");
        document
          .querySelector(".intro-content")
          .classList.remove("intro-hover");
      } else {
        document
          .querySelector(".intro-content")
          .classList.remove("none-height");
        document.querySelector(".intro-content").classList.add("intro-hover");
      }
    },
    getRouteLink: function (slug, type, base = '') {
      const post_types = Object.values(global.wpvue_script_data_params.data.post_types)
      if (slug === 'home') {
        return `/`
      } else {
        if (post_types.indexOf(type) > -1)
          return (base) ? `/${base}/${slug}` : `/${type}/${slug ? slug.replace('/', '') : ''}`
        else
          return (base) ? `/${base}/${slug}` : `/${slug ? slug.replace('/', '') : ''}`
      }
    },
    getAltText: function (altText, url) {
      let textAlt = ''
      if (altText && altText != '') {
        textAlt = altText
      } else {
        if (url)
          textAlt = url.substring(url.lastIndexOf('/') + 1).split('.')[0]
      }
      return textAlt
    },
  },
  created() {
    this.introinnerWidth = window.innerWidth;
  },
  mounted() {
    this.$nextTick(() => {});
    window.addEventListener("resize", () => {
      this.introinnerWidth = window.innerWidth;
    });
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.intro-block {
  padding-bottom: 26px;
}

.show-cls {
  display: block;
  text-decoration: underline;
  cursor: pointer;
  padding-bottom: 5px;
}

.content {
  &-left {
    text-align: left;
  }
  &-center {
    text-align: center;
  }
  &-right {
    text-align: right;
  }
}

.intro-content {
  position: relative;
  overflow: hidden;
}

.none-height {
  max-height: none !important;
}

.intro-hover {
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: block;
    height: 26px;
    background: linear-gradient(
      360deg,
      var(--bg-color) 100.95%,
      transparent 360%
    );
    opacity: 0.5;
  }
}

.author-section {
  background: transparent;
}

.author-section .row {
  padding-left: 0;
  padding-right: 0;
}

.author-section .row .col-lg-3 {
  padding-left: 0;
  padding-right: 0;
}

.author-wrapper-big-card {
  display: flex;
  flex-direction: column;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #FFFFFF;
  padding: 16px;
}
@media (min-width: 576px) {
  .author-wrapper-big-card {
    flex-direction: row;
  }
}
.author-wrapper-big-card .author-img {
  display: flex;
  margin-right: 10px;
}
.pubdate {
  float: right;
}
.publish-date {
  font-size: 12px;
  color: #9b9b9b;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &-icon {
    margin-right: 6px;
    margin-top: 2px;
  }
}
@media (min-width: 576px) {
  .author-wrapper-big-card .author-img {
    width: 50%;
  }
}
.author-wrapper-big-card .author-img img {
  width: 70px;
  height: 70px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-right: 16px;
}
@media (min-width: 576px) {
  .author-wrapper-big-card .author-img img {
    width: 100px;
    height: 100px;
  }
}
.author-wrapper-big-card .author-img-content {
  line-height: 18px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (min-width: 576px) {
  .author-wrapper-big-card .author-img-content {
    height: 100px;
  }
}
.author-wrapper-big-card .author-img-content .span-h2 {
  margin: 0;
  line-height: 32px;
}
.author-wrapper-big-card .author-img-content p.mob-nam {
  margin: 0;
  font-weight: 700;
}
.author-wrapper-big-card .author-img-content .span-title {
  color: #9b9b9b;
}
.author-wrapper-big-card .author-img-content a {
  cursor: pointer;
}
.author-wrapper-big-card .author-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (min-width: 576px) {
  .author-wrapper-big-card .author-content {
    width: calc(50% - 10px);
  }
}
@media (max-width: 576px) {
  .author-wrapper-big-card .author-content {
    margin-top: 16px;
  }
}
.author-wrapper-big-card .author-content .span-h5 {
  margin: 0;
}
.author-wrapper-big-card .author-content p {
  margin: 0;
}
.author-wrapper-small-card {
  display: flex;
  flex-direction: row;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-bottom: 16px;
  margin-right: 10px;
}
.author-wrapper-small-card img {
  width: 40px;
  height: 40px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  margin-right: 16px;
}
.author-wrapper-small-card .author-img-content {
  line-height: 18px;
  display: flex;
  flex-direction: column;
}
.author-wrapper-small-card .author-img-content .inner-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.author-wrapper-small-card .author-img-content .inner-wrap a {
  width: auto;
  height: auto;
  margin-left: 0;
}
.author-wrapper-small-card .author-img-content .p-bold {
  margin: 0;
  font-weight: 700;
  color: #fff;
}
.author-wrapper-small-card .author-img-content .span-caption {
  color: #9b9b9b;
  line-height: 10px;
}
.author-wrapper-small-card .author-img-content a {
  cursor: pointer;
  margin-left: 8px;
  width: 16px;
  height: 16px;
}
.author-desktop-version {
  display: none;
}
@media (min-width: 576px) {
  .author-desktop-version {
    display: flex;
  }
}
.author-mobile-version {
  display: flex;
}
@media (min-width: 576px) {
  .author-mobile-version {
    display: none;
  }
}
@media (min-width: 768px) {
  .full-card {
    flex-direction: column !important;
  }
  .full-card-img {
    width: 100% !important;
    margin-right: 0px !important;
  }
  .full-card-content {
    width: 100% !important;
    margin-top: 10px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/IntroBlock.vue